import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider, useApp } from './context/AppContext';
import MainLayout from './components/layout/MainLayout';
import OrdersView from './pages/orders/OrdersView';
import HomeView from './pages/Home.view';
import ReportsView from './pages/Reports.view';
import ProductsListView from './pages/ProductsList.view';
import CategoriesView from './pages/Categories.view';
import SettingsPageView from './pages/SettingsPage.view';
import HelpView from './pages/Help.view';
import LoginView from './pages/Login.view';
import ProjectorView from './pages/ProjectorView';
import useIdleTimeout from './hooks/useIdleTimeout';

function AppContent() {
  const { currentUser, login, logout } = useApp();

  // Idle timeout of 120 minutes
  useIdleTimeout({
    onTimeout: () => {
      if (currentUser) {
        logout();
      }
    },
    timeoutMs: 120 * 60 * 1000
  });

  return (
    <Routes>
      {/* Public Projector Screen accessible without login */}
      <Route path="/projetor" element={<ProjectorView />} />

      {/* Protected UI inside standard MainLayout */}
      <Route
        path="/*"
        element={
          !currentUser ? (
            <LoginView onLoginSuccess={(user, token) => login(user.email, user.name, user.role, user.permissions, token)} />
          ) : (
            <MainLayout>
              <Routes>
                <Route path="/" element={<Navigate to="/home" replace />} />
                <Route path="/home" element={<HomeView />} />
                
                <Route 
                  path="/orders" 
                  element={
                    (currentUser?.role === 'ADM' || currentUser?.permissions?.view?.pedido === true) 
                      ? <OrdersView /> 
                      : <Navigate to="/home" replace />
                  } 
                />
                
                <Route 
                  path="/reports" 
                  element={
                    (currentUser?.role === 'ADM' || currentUser?.permissions?.view?.relatorios === true) 
                      ? <ReportsView /> 
                      : <Navigate to="/home" replace />
                  } 
                />
                
                <Route 
                  path="/products/list" 
                  element={
                    (currentUser?.role === 'ADM' || currentUser?.permissions?.view?.produto === true) 
                      ? <ProductsListView /> 
                      : <Navigate to="/home" replace />
                  } 
                />
                
                <Route 
                  path="/products/categories" 
                  element={
                    (currentUser?.role === 'ADM' || currentUser?.permissions?.view?.categoria === true) 
                      ? <CategoriesView /> 
                      : <Navigate to="/home" replace />
                  } 
                />
                
                <Route 
                  path="/settings" 
                  element={
                    (currentUser?.role === 'ADM' || currentUser?.permissions?.view?.configuracao === true) 
                      ? <SettingsPageView /> 
                      : <Navigate to="/home" replace />
                  } 
                />
                
                <Route path="/help" element={<HelpView />} />
                {/* Wildcard Fallback */}
                <Route path="*" element={<Navigate to="/home" replace />} />
              </Routes>
            </MainLayout>
          )
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AppProvider>
      <HashRouter>
        <AppContent />
      </HashRouter>
    </AppProvider>
  );
}

